import React from 'react';
import styles from './styles.module.scss';
import { formatSubscriptionAmount } from '../../../utils/currency';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface ComponentProps {
  amount: number;
  country: CountryCode;
  description?: string;
  meteredBillingString?: string;
  name?: string;
}

export const PricingDetail: React.FC<ComponentProps> = ({ amount, country, description, name , meteredBillingString}): JSX.Element => {
  const { t } = useTranslation();
  const formattedAmount = formatSubscriptionAmount(amount, country, true);
  const subscriptionPricingString = meteredBillingString ? amount === 0 ? `${t('pay_per_action_fee')} ${meteredBillingString}` : `${formattedAmount.short} + ${t('pay_per_action_fee')} ${meteredBillingString}` : formattedAmount.short;
  return (
    <div className={styles.pricingDetail}>
      <Typography variant="subtitle1" color="textPrimary" classes={{subtitle1: styles.subtitle}}>
        {name}
      </Typography>
      {formattedAmount && <Typography variant='body1' color='textSecondary'>
        {subscriptionPricingString}
      </Typography>}
      {description && <Typography variant='body1' className={styles.appDesc}>
        {description}
      </Typography>}
    </div>
  );
};
